import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import HomeOne from './HomeOne'
import About from './About'
import LoadTop from '../Components/LoadTop'
import Destination from './Destination'
import Service from './Service'
import Gallery from './Gallery'
import Error from './Error'
import Blog from './Blog'
import BlogDetails from './BlogDetails'
import Contact from './Contact'
import HeaderOne from '../Components/Header/HeaderOne'
import FooterOne from '../Components/Footer/FooterOne'
import { apiUrl } from '../Constants/contant'
import ServiceDetailsMain from '../Components/Services/ServiceDetailsMain'
function RouterPage() {

  const [category, setCategory] = useState([]);
  const [destination,setDestination] = useState([]);
  const [data, setData] = useState([]);

useEffect(() => {
  fetch(apiUrl + 'front')
    .then(response => response.json()) // ✅ JSON convert
    .then(data => {
      setData(data);
      setCategory(data.category);
      setDestination(data.d_category);
    })
    .catch(error => {
      console.error("There was an error fetching sliders!", error);
    });
}, []);


  return (    
    <div>

      <Router>
        <LoadTop />
        <HeaderOne categories={category} destination={destination}/>

        <Routes>

          <Route path="/" element={<HomeOne data={data}/>}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/destination/:id" element={<Destination />}></Route>
          <Route path="/service/:id" element={<Service />}></Route>
          <Route path="/service-details/:id" element={<ServiceDetailsMain />}></Route>

          <Route path="/gallery" element={<Gallery />}></Route>
          <Route path="/error" element={<Error />}></Route>
          <Route path="/blog" element={<Blog />}></Route>
          <Route path="/blog/:id" element={<BlogDetails />}></Route>
          <Route path="/contact" element={<Contact />}></Route>

          
        </Routes>

        <FooterOne />

      </Router>
    </div>
  )
}

export default RouterPage